import moment from 'moment';
import _ from 'lodash';
import angular from 'angular';

class DashboardMovementsController {
  /* @ngInject */
  constructor($filter, $log, $rootScope, StorageService , $translate, MovementsService, NewInstrumentHistoryService, StoreService, PaginationSettings, NewTokenService) {
    const that = this;
    const BE_PAGINATION = 1000;
    that.loading = {
      instruments: false,
      movements: false,
      store: false
    };

    that.store = undefined;
    that.filters = {};
    that.filterOptions = {};
    that.scaRequired = false;

    that.pagination = {
      currentPage: {
        number: 0,
        data: []
      },
      pageSize: 0
    };

    const date = new Date();
    that.start = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    that.end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    that.maxDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    that.profile = NewTokenService.getUserContext().profile;
    that.pageNumber = 0

    let options;
    let movements;

    const loadStores = () => {
      that.loading.store = true;
      StoreService.getStoreList().then(res => {
          that.filters.store.options = _.map(res, (store) => ({
            id: store.id,
            name: store.name
          }));
      }).finally( () => {
        that.loading.store = false;
      })
    };

    const processMovements = rawMovements => _.map(rawMovements, movement => (
    {
      //title: movement.title+" "+movement.message,
      contact: {
        title: movement.title,
        name: movement.objectAlias ? movement.objectAlias : movement.message
      },
      transactionId : movement.transactionId,
      date: movement.lastModifiedDate,
      amount: parseFloat(movement.amount).toFixed(2),
      fee: parseFloat(movement.fee).toFixed(2),
      direction:  movement.direction == "INCOMING" ? 'in' : 'out'
    }));

    that.changePage = (page = 0) => {
      if (movements === undefined) return;
      that.pagination.currentPage.number = page;
      loadCCMovements();
    };

    const makeOptions = () => {
      options = {
        pagination: {
          elementiPerPagina: that.isCondensed ? PaginationSettings.CONDENSED_PAGE_SIZE : BE_PAGINATION,
        },
        filterOptions: {}
      };

      return options;
    };

    const filterMovements = (rawMovements) => {
      let filteredList = rawMovements;

      if (that.filters.search.terms.length > 0) {
        const movementIds = [];

        _.forEach(filteredList, (movement) => {
          let match = true;

          _.forEach(that.filters.search.terms, (term) => {
            const searchRegexp = new RegExp(`^.*${term}.*$`, 'i');
            // search in movement contact
            if (movement.contactName) {
              if (searchRegexp.test(movement.contactName)) return;
            }

            if (movement.contactSurname) {
              if (searchRegexp.test(movement.contactSurname)) return;
            }

            // search in movement description
            if (movement.description) {
              if (searchRegexp.test(movement.description)) return;
            }

            match = false;
          });

          if (match) {
            if (movementIds.indexOf(movement.transactionId) === -1) {
              movementIds.push(movement.transactionId);
            }
          }
        });

        filteredList = _.filter(filteredList, (movement) => movementIds.indexOf(movement.transactionId) > -1);
      }

      return filteredList;
    };

    const buildFilters = (getAllItem) =>{
      if (that.filters.time.value !== 'any' && that.filters.time.value !== 'datepicker') {
        that.filterOptions = NewInstrumentHistoryService.createDefaultRangeOptions(that.filters.time.value, {});
      } else if (that.filters.time.value === 'datepicker') {
        that.filterOptions = {
          dateStart: moment(that.start).format('YYYYMMDD'),
          dateEnd: moment(that.end).format('YYYYMMDD')
        };
      }

      if (that.filters.store.value !== 'any') {
        that.filterOptions.shopId = that.filters.store.value.id;
    }

      if(that.filters.type.value !== 'any'){
        that.filterOptions.direction = that.filters.type.value == 'in' ? "INCOMING" : "OUTGOING";
      }

      that.filterOptions.page = that.pagination.currentPage.number;
      that.filterOptions.size = !getAllItem ? that.pagination.pageSize : 5000
      that.filterOptions.returnBankAccount = true
      that.filterOptions.sort = "lastModifiedDate,desc"
      that.filterOptions.excludePayPal = true;
    }

    const loadCCMovements = () => {
      if (that.loading.movements) return;

      that.loading.movements = true;
      buildFilters(false)
      NewInstrumentHistoryService.getTinabaInstrumentHistory(that.filterOptions).then((movementsResult) => {
      if(StorageService.getLocalStorage('superAdmin') !== "true" ) that.scaRequired = movementsResult.scaType
      movements = movementsResult.resultList;
      that.pagination.currentPage.data = processMovements(movements);
      that.setCurrentPageIndex(movementsResult['pagination']['number']);
      var pn = that.pageNumber == 0 ? movementsResult['pagination']['totalPages']: that.pageNumber
      that.setPagesNumber(pn);
      }, (reason) => {
        movements = [];
        $log.error('DashboardMovementsController', 'loadMovements', reason);
      }).finally(() => {
        that.loading.movements = false;
      });
    };

    const loadAllCorporateMovements = () => {
      if (that.loading.movements) return;

      that.loading.movements = true;
      buildFilters(true)
      NewInstrumentHistoryService.getTinabaInstrumentHistory(that.filterOptions).then((movementsResult) => {
      if(StorageService.getLocalStorage('superAdmin') === "false" ) that.scaRequired = movementsResult.scaType
      that.pageNumber = Math.ceil(movementsResult['pagination']['totalElements']/that.pagination.pageSize)
      }, (reason) => {
        movements = [];
        $log.error('DashboardMovementsController', 'loadMovements', reason);
      }).finally(() => {
        that.loading.movements = false;
        if(!that.scaRequired)
          loadCCMovements()
      });
    };


    const loadMovements = () => {
      var merchantProfile = angular.fromJson(StorageService.getLocalStorage('userContext'));
      if(merchantProfile.business.wallet.type == "CORPORATE"){
        loadAllCorporateMovements();
      }else{
        loadCCMovements();
      }

    }


    const resetFilters = () => {
      let stores = [];
      if (that.filters && that.filters.store && that.filters.store.options.length > 0) {
        stores = that.filters.store.options;
      }
      that.filters = {
        type: {
          value: 'any',
          string: $filter('translate')('common.any')
        },
        time: {
          value: '1',
          string: $filter('translate')('common.date.current_month')
        },
        search: {
          terms: [],
          text: ''
        },
        store: {
          value: 'any',
          string: $translate.instant('common.any'),
          options: stores
        },
      };

      loadMovements();
    };

    that.resetFilters = resetFilters;

    const applyFilters = () => {
      that.pagination.currentPage.number = 0;

      /*if (that.filters.type.value === 'any') {
        that.filters.type.string = $filter('translate')('common.any');
      } else {*/
        that.filters.type.string = $filter('translate')(`dashboard.movements.filter.options.type.${that.filters.type.value}`);
      //}

      /*if (that.filters.time.value === 'any') {
        that.filters.time.string = $filter('translate')('common.any');
      } else*/
       if (that.filters.time.value === 'datepicker') {
        that.filters.time.string = `Dal ${$filter('amDateFormat')(that.start, 'DD/MM/YYYY')} al ${$filter('amDateFormat')(that.end, 'DD/MM/YYYY')}`;
      } else {
        that.filters.time.string = `${that.filters.time.value} ${that.filters.time.value > 1 ? $filter('translate')('common.date.months') : $filter('translate')('common.date.month')}`;
      }

      /*if (that.filters.store.value === 'any') {
        that.filters.store.string = $translate.instant('common.any');
      } else {*/
        that.filters.store.string = that.filters.store.value.name + ' - ' + that.filters.store.value.id;
      //}

      loadMovements();
    };

    that.applyFilters = applyFilters;

    const loadUserInstrument = () => {
        loadMovements();
    };


    const init = () => {
      that.isCondensed = that.condensed !== undefined;
      that.pagination.pageSize = that.isCondensed ? PaginationSettings.CONDENSED_PAGE_SIZE : PaginationSettings.DEFAULT_PAGE_SIZE;
      this.pageChangedCallback = (index = 0) => {
        that.changePage(index);
      };
      loadStores();
      makeOptions();
      resetFilters();
      that.changePage();
      //loadUserInstrument();
    };

    that.$onInit = init;

    that.onSearch = loadMovements;

     that.onScaCompleted = () => {
      that.scaRequired = false
      loadMovements();
     }

    const deregUserInstrumentListUpdateListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE', loadUserInstrument);
    const deregUserInstrumentListFailListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE_FAIL', () => {
      that.loading.instruments = false;
    });

    that.exportCsv = () => {
      if (that.filterOptions.dataDa === undefined) {
        that.filterOptions.dateStart = moment(that.start).format('YYYYMMDD');
        that.filterOptions.dateEnd = moment(that.end).format('YYYYMMDD');
      }
      MovementsService.exportCsv(that.filterOptions);
    };

    that.$onDestroy = () => {
      deregUserInstrumentListUpdateListener();
      deregUserInstrumentListFailListener();
    };
  }
}

export default DashboardMovementsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/movements/movements.controller.js
 **/